var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.subject)?_c('span',{class:("badge " + _vm.badgeClass + " mr-1")},[_vm._v("\n  "+_vm._s(_vm.subject)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }